(function () {
  /* Flush Fittings collection content (30 October 2026). Loaded by sections/collection-content.liquid only.
     1. Labels any specification table cell that the section's Liquid could not label (data-label, read by the CSS for the stacked phone layout). Tables written to the standard arrive labelled from the server.
     2. Marks the jump link of the section in view (desktop rail).
     3. Sends two PostHog events when PostHog is present: ff_faq_open (an FAQ answer opened) and ff_jump_click (a jump link used). */
  function track(name, props) {
    try {
      if (window.posthog && typeof window.posthog.capture === 'function') window.posthog.capture(name, props);
    } catch (e) {}
  }
  function labelTables() {
    var tables = document.querySelectorAll('.collection--spec table');
    Array.prototype.forEach.call(tables, function (table) {
      var heads = Array.prototype.map.call(table.querySelectorAll('thead th'), function (th) {
        return th.textContent.replace(/\s+/g, ' ').trim();
      });
      if (!heads.length) return;
      Array.prototype.forEach.call(table.querySelectorAll('tbody tr'), function (tr) {
        Array.prototype.forEach.call(tr.children, function (cell, i) {
          if (i > 0 && heads[i] && !cell.hasAttribute('data-label')) cell.setAttribute('data-label', heads[i]);
        });
      });
    });
  }
  function watchSections() {
    var links = document.querySelectorAll('.ff-jump__link');
    if (!links.length) return;
    var pairs = [];
    Array.prototype.forEach.call(links, function (a) {
      var id = (a.getAttribute('href') || '').replace(/^.*#/, '');
      var el = id && document.getElementById(id);
      if (el) pairs.push({ link: a, el: el });
      a.addEventListener('click', function () {
        track('ff_jump_click', { target: id, label: a.textContent.trim() });
      });
    });
    if (!pairs.length) return;
    var ticking = false;
    function update() {
      ticking = false;
      var current = null;
      for (var i = 0; i < pairs.length; i++) {
        if (pairs[i].el.getBoundingClientRect().top <= 130) current = pairs[i];
      }
      for (var j = 0; j < pairs.length; j++) {
        if (pairs[j] === current) pairs[j].link.classList.add('is-current');
        else pairs[j].link.classList.remove('is-current');
      }
    }
    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    update();
  }
  function watchFaq() {
    var items = document.querySelectorAll('.collection--faq details');
    Array.prototype.forEach.call(items, function (d) {
      d.addEventListener('toggle', function () {
        if (!d.open) return;
        var h = d.querySelector('summary h3');
        track('ff_faq_open', { question: h ? h.textContent.trim() : '' });
      });
    });
  }
  function init() {
    labelTables();
    watchSections();
    watchFaq();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
